export default __webpack_public_path__ + "static/media/2-shine.c51ed1fe.png";